/**
 * @param {(arg0: any) => any} fetcher
 * @param {any} requestData
 */
export async function reactQueryCompatibleFetcher(fetcher, requestData) {
  const res = await fetcher(requestData);

  if (res?.isSuccess) {
    return res;
  }
  return Promise.reject(res);
}
